'use client';
import { FeatureFlags } from '@scaleup/models';
import { createContext } from 'react';

type FeatureFlagContextProps = {
  featureFlags?: FeatureFlags;
};

export const FeatureFlagContext = createContext<FeatureFlagContextProps>({});
